import React from "react";
import Top5SpaImgBanner from "./../../../../../Images/Blog/The_Top_5_Hair_Spa_Today/Banner.png";

const Top5SpaImg = () => {
  return (
    <div className="pediManicureImg">
      <img src={Top5SpaImgBanner} alt="spaDayBanner" loading="lazy" />
    </div>
  );
};

export default Top5SpaImg;
